export default {
  title: 'Nowości w Qmulus',
  titleWithVersion: 'Nowości w wersji {version}',
  doNotShowAfterUpdates: 'Nie pokazuj przy kolejnych aktualizacjach',
  showAllReleases: 'Pokaż wszystkie nowości',
};
